export default "__VITE_ASSET__DHkm6smi__"